export default __webpack_public_path__ + "static/media/wa-background.cd00123e.png";